import type { OrganizationsResponseData } from '../../types.tsx';

export const mapDataToOrganizationOptions = (data: OrganizationsResponseData) =>
	data?.results?.results?.map(({ id, name }) => ({
		label: name,
		value: `${id}`, // the AK Select component options require string values
	})) || [];
